import { fetchLoginCall } from "../ajax";
import { API_CONSTANTS, API_METHODS } from "../api-constant";

export const GetAllDeviceForLogs = async (payload) => {
  const url = `${API_CONSTANTS.GET_ALL_DEVICE_LOGS}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetCalendarDataForLogs = async (userId) => {
  const url = `${API_CONSTANTS.GET_CALENDAR_DATA_FOR_LOGS}?userId=${userId}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const GetCalendarDataForDeviceLogs = async (deviceName) => {
  const url = `${API_CONSTANTS.GET_CALENDAR_DATA_FOR_LOGS}?deviceName=${deviceName}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const GetCalendarDataForLogsInHP = async (userId) => {
  const url = `${API_CONSTANTS.GET_HP_CALENDAR_DATA_FOR_LOGS}?userId=${userId}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const GetCalendarDataForDeviceLogsInHP = async (deviceName) => {
  const url = `${API_CONSTANTS.GET_HP_CALENDAR_DATA_FOR_LOGS}?deviceName=${deviceName}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const GetUserActivityLogs = async (payload, id) => {
  const url = `${API_CONSTANTS.GET_ALL_ACTIVITY_LOG_BY_ID}?userId=${id}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetUserActivityLogsHP = async (payload, id) => {
  const url = `${API_CONSTANTS.GET_ALL_ACTIVITY_LOG_HP_BY_ID}?userId=${id}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetUserActivityLogsForDevice = async (payload, deviceName) => {
  const cleanDeviceName = deviceName.replace(/\s+/g, ""); // removes all spaces
  const url = `${API_CONSTANTS.GET_ALL_ACTIVITY_LOG_BY_ID}?deviceName=${cleanDeviceName}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetUserActivityLogsForDeviceHp = async (payload, deviceName) => {
  const cleanDeviceName = deviceName.replace(/\s+/g, ""); // removes all spaces
  const url = `${API_CONSTANTS.GET_ALL_ACTIVITY_LOG_HP_BY_ID}?deviceName=${cleanDeviceName}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};
